import styled from 'styled-components';

export const NavItems = styled.div`
  flex: none;
  display: flex;
  margin-bottom: 1.2rem;
  justify-content: space-around;
`;

export const Container = styled.div`
  transform: translateY(27px);
  margin-top: -34px;
  z-index: 100;
`;
